import { isEmpty } from 'lodash'

export default {
  state: {
    isVisible: false,
    text: '',
    color: '', // [ 'success', 'info', 'warning', 'error' ]
  },
  mutations: {
    updateVisibility(state, val) {
      state.isVisible = !!val
    },
    showSnack(state, data) {
      state.text = data.text
      state.color = data.color
      state.isVisible = true
    }
  },
  getters: {
    getSnackBarColor(state) {
      return state.color
    },
    getSnackBarTimeout(state) {
      return state.timeout
    },
    getSnackBarText(state) {
      return state.text
    }
  },
  actions: {
    snackError({ dispatch }, errorObject) {
      let text = 'error'
      const { data = null, text: overrideText = '', code, message } = errorObject || {}

      if (data) {
        const { message, code = 'error' } = data
        text = `${message} [${code}]`
      } else if (message) {
        text = `${message} [${code || 'error'}]`
      } else if (overrideText) {
        text = overrideText
      }

      const payload = {
        text,
        color: 'error'
      }

      dispatch('snackBar', payload)
    },
    snackSuccess({ dispatch }, data) {
      const { text } = data
      const payload = {
        text,
        color: 'success'
      }

      dispatch('snackBar', payload)
    },
    snackBar({ commit }, data) {
      const { text, color } = data
      const payload = { text, color }

      commit('showSnack', payload)
    }
  }
}
